import {
  ButtonPrimeReact,
  Checkbox,
  InputCurrency,
  PrimeReactModal,
} from "@finanedi.es/storybook"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useCuentasBancariasAll } from "api/CuentaBancaria.hook"
import { getCuentaBancariaById } from "api/CuentaBancaria.service"
import { GetCuentasBancariasByFiltersDtoProps } from "api/DTOs/GetCuentasBancariasByFiltersDto"
import { getEtiquetasEmpresa } from "api/Etiqueta.service"
import { CATEGORIA_CUENTA_CONTABLE_ENUM } from "api/Types/CategoriaCuentaContableEnum"
import DropdownContactos from "common/components/ContactsDropdown/ContactsDropdown"
import { formatNumber } from "common/utils/currency"
import { MODAL_STYLES } from "constants/primereactStyles"
import useCuentasContables from "features/Tesoreria/hooks/useCuentasContables"
import { ErrorMessage, FieldArray } from "formik"
import { Dropdown, DropdownChangeParams } from "primereact/dropdown"
import { InputNumber, InputNumberChangeParams } from "primereact/inputnumber"
import { InputText } from "primereact/inputtext"
import { SyntheticEvent, useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { useHistory } from "react-router-dom"
import { v4 as uuidv4 } from "uuid"
import MobileCamera from "../../../MobileCamera"
import {
  ConceptosTicketsProps,
  ErrorsTicketsFormProps,
  InsertTicketProps,
  TouchedTicketsFormProps,
} from "../FormTicketNew"
import { DropdownCategoryTemplate } from "./DropdownCategorieTemplate"

type PushFunction<T> = (value: T) => void

interface ContentFromTicketsProps {
  validateField: (arg: string) => void
  setFieldValue: (arg: string, value: $TSMigrationFixMe) => void
  values: InsertTicketProps
  errors: ErrorsTicketsFormProps
  touched: TouchedTicketsFormProps
  isNew: boolean
  isMobile: boolean
  setIsMobile: React.Dispatch<React.SetStateAction<boolean>>
  handleSubmit: () => Promise<void>
  imageData: string
  setImageData: React.Dispatch<React.SetStateAction<string>>
  isSubmitting: boolean
}

const ContentFromTickets = ({
  validateField,
  setFieldValue,
  values,
  errors,
  touched,
  isNew,
  isMobile,
  setIsMobile,
  handleSubmit,
  imageData,
  setImageData,
  isSubmitting,
}: ContentFromTicketsProps) => {
  const history = useHistory()
  const data = history.location.state?.ticket
  const { t } = useTranslation()
  const { getCuentaContablePorDefecto } = useCuentasContables()
  const initialPorDefectoTicketReembolso = getCuentaContablePorDefecto(
    CATEGORIA_CUENTA_CONTABLE_ENUM.TICKET_REEMBOLSO
  )
  const [isOpen, setIsOpen] = useState(false)
  const { cuentaBancariaAll } = useCuentasBancariasAll({})

  const [imageSize, setImageSize] = useState<number | null>(null)
  const [showPreviewImg, setShowPreviewImg] = useState(false)
  const handleDropdownOptions = async () => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const cuentaBancaria = cuentaBancariaAll?.items?.find(
      (cuenta: GetCuentasBancariasByFiltersDtoProps) =>
        cuenta?.cuentaContableEmpresaId === values.cuentasContables?.bancariaId
    )
    if (cuentaBancaria?.id) {
      const data = await getCuentaBancariaById(cuentaBancaria.id)
      setFieldValue("cuentasContables.bancariaId", cuentaBancaria.id)
      setFieldValue("contableEmpresaId", data?.cuentaContableEmpresaId)
    }
  }

  const handleClick = () => {
    setIsOpen(!isOpen)
  }
  useEffect(() => {
    !isNew && handleDropdownOptions()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cuentaBancariaAll?.items?.length])

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [categoryOptions, setCategoryOptions] = useState<Array<any>>()

  useEffect(() => {
    getEtiquetasEmpresa().then((data) => {
      const etiquetasArray = data?.items?.flatMap((item) => ({
        cuentaContableId: item.cuentaContableId,
        icono: item.icono,
        nombre: item.nombre,
      }))

      const defaultCategory = etiquetasArray?.find(
        (item) => item.nombre === values?.categoria?.nombre
      )

      if (defaultCategory) {
        setCategoryOptions(etiquetasArray)
        setFieldValue("categoria", defaultCategory)
      } else {
        setCategoryOptions(
          etiquetasArray
            ? [...etiquetasArray, values.categoria]
            : [
                {
                  ...values?.categoria,
                  cuentaContableId: values?.cuentasContables?.categoriaId,
                },
              ]
        )
      }
      setFieldValue("categoria", values?.categoria)
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleCuentaBancaria = async (e: DropdownChangeParams) => {
    if (e.target.value === initialPorDefectoTicketReembolso) {
      setFieldValue("cuentasContables.bancariaId", e.target.value)
      setFieldValue("contableEmpresaId", e.target.value)
      return
    }
    const matchAccount = cuentaBancariaAll?.items?.find(
      (cuenta: GetCuentasBancariasByFiltersDtoProps) =>
        cuenta?.cuentaContableEmpresaId === e.target.value ||
        cuenta?.id === e.target.value
    )?.cuentaContableEmpresaId
    setFieldValue("cuentasContables.bancariaId", e.target.value)
    setFieldValue("contableEmpresaId", matchAccount)
  }

  const addDefaultConcept = (push: PushFunction<ConceptosTicketsProps>) => {
    push({
      id: uuidv4(),
      nombre: "",
      cantidad: 0,
      precio: 0,
      total: 0,
    })
  }
  const [showCamera, setShowCamera] = useState(false)

  const onConfirm = (img: string) => {
    if (img) {
      setImageData(img)
      setShowCamera(false)
    }
  }

  const [isActiveReembolso, setIsActiveReembolso] = useState(
    Boolean(values?.empleadoId)
  )
  const handleReembolsoChange = () => {
    if (isActiveReembolso) {
      setFieldValue("empleadoId", null)
      setIsActiveReembolso(false)
    } else {
      setFieldValue("empleadoId", true)
      validateField("cuentasContables.bancariaId")
      setIsActiveReembolso(true)
    }
  }

  useEffect(() => {
    isMobile && !imageData && setShowCamera(true)
    const handleResize = () => {
      setIsMobile(window.matchMedia("(max-width: 1023px)").matches)
    }

    !isMobile && setShowPreviewImg(false)

    window.addEventListener("resize", handleResize)
    return () => window.removeEventListener("resize", handleResize)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMobile])

  useEffect(() => {
    if (errors.cuentasContables?.bancariaId) {
      setIsOpen(true)
    }
  }, [errors])

  const handleImgSize = () => {
    if (!imageSize) return "0 B"
    if (imageSize < 100000) return `${(imageSize / 1024).toFixed(2)} KB`
    return `${(imageSize / 1048576).toFixed(2)} MB`
  }

  const handleImg = async () => {
    const response = await fetch(imageData)
    const blob = await response.blob()
    setImageSize(blob.size)
  }

  useEffect(() => {
    if (imageData) {
      handleImg()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [imageData])

  return (
    <div className='tw-flex tw-flex-col tw-bg-simple-10 lg:tw-bg-transparent'>
      <div className='lg:tw-hidden tw-flex tw-flex-row tw-justify-between tw-p-4 tw-mb-1 tw-shadow'>
        <div className='tw-flex tw-flex-row'>
          {imageData && (
            <img
              className='tw-w-14 tw-h-14 tw-object-cover'
              src={imageData}
              alt='Captured'
            />
          )}
          <div className='tw-pl-4 tw-flex tw-flex-col tw-justify-center tw-text-left'>
            <span className='tw-font-medium tw-text-sm'>
              {t("tickets.form.ticket")}
            </span>
            <span className='tw-text-left tw-font-medium tw-text-sm tw-text-neutral-75'>
              {handleImgSize()}
            </span>
          </div>
        </div>
        <div className='tw-flex tw-flex-row'>
          <button
            type='button'
            onClick={() => setShowCamera(true)}
          >
            <FontAwesomeIcon
              icon={["fal", "trash-can"]}
              className='tw-w-5 tw-h-5 tw-text-danger'
            />
          </button>
          <button
            className='tw-ml-4'
            type='button'
            onClick={() => setShowPreviewImg(!showPreviewImg)}
          >
            <FontAwesomeIcon
              icon={["fal", "eye"]}
              className='tw-w-5 tw-h-5 tw-text-text-hyperlinks'
            />
          </button>
        </div>
      </div>
      <div className='tw-flex tw-flex-col tw-p-4 tw-bg-simple-10 lg:tw-rounded tw-shadow'>
        <p className='tw-m-0 tw-font-medium tw-text-lg tw-text-left'>
          {t("tickets.form.dataTicket")}
        </p>

        <div className='lg:tw-grid lg:tw-grid-cols-2 lg:tw-gap-4 tw-mt-4'>
          <div className='tw-flex tw-flex-col tw-items-start tw-mb-4 lg:tw-mb-0'>
            <p className='tw-mb-2'>
              {isMobile ? "Concepto" : t("tickets.form.nameTicket")}
            </p>
            <InputText
              name='nombre'
              value={values.nombre ?? ""}
              className={`${
                errors?.nombre && touched?.nombre ? "!tw-border-danger" : ""
              } !tw-w-full !tw-h-10 !tw-rounded`}
              placeholder={
                isMobile
                  ? "Introduce el concepto"
                  : `${t("tickets.form.placeholder.nombre")}`
              }
              onChange={(e: SyntheticEvent<HTMLInputElement>) => {
                setFieldValue("nombre", e.currentTarget.value)
                isMobile &&
                  setFieldValue("conceptos[0].nombre", e.currentTarget.value)
              }}
            />
            <ErrorMessage
              name='nombre'
              component='div'
              className='!tw-block !tw-w-full !tw-text-left !tw-text-danger'
            />
          </div>
          <div className='tw-flex tw-flex-col tw-items-start tw-mb-4 lg:tw-mb-0'>
            <p className='tw-mb-2'>{t("tickets.form.categoriaTicket")}</p>
            <Dropdown
              id='categoria'
              name='categoria'
              value={values?.categoria}
              onChange={(e: DropdownChangeParams) => {
                setFieldValue("categoria", e.target.value)
              }}
              options={categoryOptions}
              optionLabel='nombre'
              valueTemplate={DropdownCategoryTemplate}
              itemTemplate={DropdownCategoryTemplate}
              editable={false}
              placeholder={`${t("tickets.form.placeholder.categoria")}`}
              className={`${
                touched?.categoria?.nombre &&
                (errors?.categoria?.nombre ||
                  errors?.categoria?.cuentaContableId)
                  ? "!tw-border-danger"
                  : ""
              } !tw-rounded tw-w-full tw-border-1 !tw-h-10 tw-items-center tw-align-middle`}
            />
            {touched?.categoria?.nombre &&
              (errors?.categoria?.nombre ||
                errors?.categoria?.cuentaContableId) && (
                <ErrorMessage
                  name={`${
                    errors?.categoria?.nombre
                      ? "categoria.nombre"
                      : "categoria.cuentaContableId"
                  }`}
                  component='div'
                  className='!tw-block !tw-w-full !tw-text-left !tw-text-danger'
                />
              )}
          </div>
          <div className='tw-flex tw-flex-col tw-items-start tw-mb-4 lg:tw-mb-0'>
            <p className='tw-mb-2'>{t("tickets.form.fechaTicket")}</p>
            <InputText
              name='fechaEmision'
              className={`${
                errors?.fechaEmision && touched?.fechaEmision
                  ? "!tw-border-danger"
                  : ""
              } !tw-w-full !tw-h-10 !tw-rounded`}
              autoComplete='nope'
              value={values.fechaEmision ?? ""}
              onChange={(e: SyntheticEvent<HTMLInputElement>) => {
                setFieldValue("fechaEmision", e.currentTarget.value)
              }}
              type='date'
            />
            <ErrorMessage
              name='fechaEmision'
              component='div'
              className='!tw-block !tw-w-full !tw-text-left !tw-text-danger'
            />
          </div>
          <div className='tw-flex tw-flex-col tw-items-start lg:tw-hidden'>
            <p className='tw-mb-2'>{t("tickets.form.importeTotalTicket")}</p>
            <InputCurrency
              placeholder='0,00'
              value={values?.conceptos?.[0]?.precio}
              className={`${
                errors?.conceptos?.[0]?.precio &&
                touched?.conceptos?.[0]?.precio
                  ? "!tw-border-danger"
                  : ""
              } !tw-w-full !tw-h-10 !tw-rounded`}
              onChange={(value) => {
                setFieldValue("conceptos[0].precio", value)
                setFieldValue("conceptos[0].cantidad", 1)
                setFieldValue("conceptos[0].total", value)
              }}
            />
          </div>
        </div>
        <FieldArray name='conceptos'>
          {({ push, remove }) => (
            <div className='tw-col-span-2 tw-hidden lg:tw-block'>
              <div className='tw-mt-4'>
                <div className='tw-w-full tw-flex tw-flex-col !tw-rounded'>
                  <div className='!tw-rounded-t'>
                    <div className='tw-bg-primary tw-h-12 tw-text-simple-10 !tw-rounded-t tw-flex tw-flex-row'>
                      <div className='tw-w-3/5 tw-flex tw-justify-start tw-items-center tw-font-normal tw-text-left tw-border-x-0 tw-px-4 !tw-rounded-tl'>
                        {t("tickets.form.conceptoNombreTicket")}
                      </div>
                      <div className='tw-w-[10%] tw-flex tw-justify-end tw-items-center tw-font-normal tw-text-end tw-border-x-0 tw-px-4'>
                        {t("tickets.form.conceptoCantidadTicket")}
                      </div>
                      <div className='tw-w-[12%] tw-flex tw-justify-end tw-items-center tw-font-normal tw-text-end tw-border-x-0 tw-px-4'>
                        {t("tickets.form.conceptoPrecioTicket")}
                      </div>
                      <div className='tw-w-[12%] tw-flex tw-justify-end tw-items-center tw-font-normal tw-text-end tw-border-x-0 tw-px-4'>
                        {t("tickets.form.conceptoTotalTicket")}
                      </div>
                      <div className='tw-w-[6%] tw-flex tw-justify-center tw-items-center tw-font-normal tw-border-x-0 tw-px-4 !tw-rounded-tr' />
                    </div>
                  </div>
                  <div className='!tw-rounded-b'>
                    {values?.conceptos?.map(
                      (concepto: ConceptosTicketsProps, index: number) => {
                        return (
                          <div
                            className='tw-h-12 tw-flex tw-flex-row'
                            key={`${concepto?.nombre + index}`}
                          >
                            <div
                              className={`tw-w-3/5 tw-flex tw-justify-start tw-items-center !tw-h-12 tw-font-normal !tw-p-0 !tw-border ${
                                errors?.conceptos?.[index]?.nombre &&
                                touched?.conceptos?.[index]?.nombre
                                  ? "!tw-border-danger"
                                  : "tw-border-netural-25"
                              }`}
                            >
                              <InputText
                                value={concepto?.nombre}
                                id='nombre'
                                name='nombre'
                                className='!tw-w-full !tw-h-11 !tw-rounded-none !tw-border-none tw-px-4 tw-text-left'
                                placeholder={`${t(
                                  "tickets.form.placeholder.concepto"
                                )}`}
                                onChange={(
                                  e: SyntheticEvent<HTMLInputElement>
                                ) => {
                                  setFieldValue(
                                    `conceptos[${index}].nombre`,
                                    e.currentTarget.value
                                  )
                                }}
                                autoFocus
                                type='text'
                              />
                            </div>
                            <div
                              className={`tw-w-[10%]  tw-flex tw-justify-center tw-items-center  tw-font-normal !tw-p-0 tw-border  ${
                                errors?.conceptos?.[index]?.cantidad &&
                                touched?.conceptos?.[index]?.cantidad
                                  ? "tw-border-danger"
                                  : "tw-border-netural-25"
                              }`}
                            >
                              <InputNumber
                                value={concepto.cantidad}
                                inputClassName='!tw-w-full !tw-text-right !tw-h-11 !tw-rounded-none !tw-border-none tw-text-left'
                                placeholder=''
                                onChange={(e: InputNumberChangeParams) => {
                                  setFieldValue(
                                    `conceptos[${index}].cantidad`,
                                    e.value
                                  )
                                  setFieldValue(
                                    `conceptos[${index}].total`,
                                    concepto.precio * e.value
                                  )
                                }}
                              />
                            </div>
                            <div
                              className={`tw-w-[12%] tw-flex tw-justify-center tw-items-center tw-font-normal !tw-p-0 tw-border  ${
                                errors?.conceptos?.[index]?.precio &&
                                touched?.conceptos?.[index]?.precio
                                  ? "tw-border-danger"
                                  : "tw-border-netural-25"
                              }`}
                            >
                              <InputNumber
                                value={concepto.precio ?? 0}
                                inputClassName='!tw-w-full !tw-h-11 !tw-text-right !tw-rounded-none !tw-border-none tw-text-left'
                                placeholder=''
                                minFractionDigits={2}
                                maxFractionDigits={2}
                                currency='EUR'
                                currencyDisplay='symbol'
                                locale='es-ES'
                                onChange={(e: InputNumberChangeParams) => {
                                  setFieldValue(
                                    `conceptos[${index}].precio`,
                                    e.value
                                  )
                                  setFieldValue(
                                    `conceptos[${index}].total`,
                                    concepto.cantidad * e.value
                                  )
                                }}
                              />
                            </div>
                            <div className='tw-w-[12%] tw-font-normal tw-border tw-border-netural-25 tw-text-right tw-py-3 tw-px-2 tw-select-none'>
                              {Intl.NumberFormat("de-DE", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              }).format(
                                concepto?.total ??
                                  concepto.precio * concepto.cantidad
                              )}
                            </div>

                            <div
                              onClick={() => {
                                values?.conceptos &&
                                  values?.conceptos?.length > 1 &&
                                  remove(index)
                              }}
                              className={`tw-w-[6%] tw-h-full tw-flex tw-justify-center tw-items-center ${
                                values?.conceptos &&
                                values?.conceptos?.length > 1
                                  ? "tw-cursor-pointer"
                                  : "disabled"
                              } tw-font-normal tw-px-4 tw-border tw-border-netural-25`}
                            >
                              <div
                                className={`tw-w-6 tw-h-6 tw-flex tw-justify-center tw-items-center ${
                                  values?.conceptos &&
                                  values?.conceptos?.length > 1
                                    ? ""
                                    : "tw-hidden"
                                }`}
                              >
                                <FontAwesomeIcon
                                  icon={["fal", "trash-can"]}
                                  className='tw-w-[17.5px] tw-h-5 tw-text-danger'
                                />
                              </div>
                            </div>
                          </div>
                        )
                      }
                    )}
                    <div
                      className={`tw-h-12 tw-flex tw-flex-row ${
                        touched?.conceptos && errors?.conceptos
                          ? ""
                          : "tw-hidden"
                      }`}
                    >
                      {touched?.conceptos && errors?.conceptos && (
                        <div className='error tw-w-full tw-text-left tw-text-danger'>
                          {t("tickets.form.errors.conceptos.conceptos")}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className='tw-w-full tw-flex tw-justify-center tw-mt-4'>
                <div
                  className='tw-w-44 tw-h-10 !tw-cursor-pointer tw-text-info-100 tw-flex tw-justify-between tw-p-2 tw-rounded tw-shadow'
                  onClick={() => addDefaultConcept(push)}
                >
                  <span className='tw-w-6 tw-h-6 tw-flex tw-justify-center tw-items-center'>
                    <FontAwesomeIcon
                      icon={["fal", "plus"]}
                      className='tw-w-4 tw-h-5'
                    />
                  </span>
                  <span className='tw-py-auto tw-pr-2'>
                    {t("tickets.form.addConceptoTicket")}
                  </span>
                </div>
              </div>
              <div className='tw-flex tw-flex-row tw-w-full tw-justify-end tw-mt-6'>
                <div className='tw-w-60 tw-flex tw-flex-row tw-justify-between tw-font-medium tw-text-lg'>
                  <div>{t("tickets.form.totalConceptoTicket")}</div>
                  <div className='tw-truncate tw-pl-2'>
                    {formatNumber(
                      values?.conceptos?.reduce(
                        (total: number, elemento: ConceptosTicketsProps) =>
                          total + (elemento.total ?? 0),
                        0
                      )
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}
        </FieldArray>
      </div>
      {isMobile && (
        <div className='tw-flex tw-flex-row tw-justify-between tw-p-4 tw-bg-simple-10 tw-shadow tw-mt-2'>
          <p className='tw-m-0 tw-font-medium tw-text-lg tw-text-left'>
            {t("tickets.form.optional")}
          </p>
          <button
            type='button'
            onClick={handleClick}
          >
            {isOpen ? (
              <FontAwesomeIcon
                icon={["fal", "angle-down"]}
                className='sb-text-lg'
              />
            ) : (
              <FontAwesomeIcon
                icon={["fal", "angle-right"]}
                className='sb-text-lg'
              />
            )}
          </button>
        </div>
      )}
      <div
        className={` ${
          isMobile ? (isOpen ? "tw-grid" : "tw-hidden") : "tw-grid"
        } lg:tw-grid-cols-2 tw-gap-4 tw-p-4 tw-bg-simple-10 lg:tw-rounded tw-shadow lg:tw-mt-4`}
      >
        {!isMobile && (
          <p className='tw-col-span-2 tw-m-0 tw-font-medium tw-text-lg tw-text-left'>
            {t("tickets.form.optional")}
          </p>
        )}
        <div className='tw-flex tw-flex-col tw-items-start'>
          <p className='tw-mb-2'>{t("tickets.form.contactoTicket")}</p>
          <DropdownContactos
            id='contacto-ticket'
            pushDefaultOption={
              data?.empresa?.id && {
                empresaContactoId: data?.empresa.id,
                razonSocial: data?.empresa.razonSocial,
              }
            }
            value={values?.empresaId}
            onchange={({ value }: { value: string }) =>
              setFieldValue("empresaId", value)
            }
          />
        </div>
        <div className='tw-flex tw-flex-col tw-items-start'>
          <p className='tw-mb-2'>{t("tickets.form.numeroTicket")}</p>
          <InputText
            value={values.numero ?? ""}
            className='!tw-w-full !tw-h-10 !tw-rounded'
            placeholder={`${t("tickets.form.placeholder.numero")}`}
            onChange={(e: SyntheticEvent<HTMLInputElement>) => {
              setFieldValue("numero", e.currentTarget.value)
            }}
          />
        </div>
        {/* TODO: endpoint.
        <div className='tw-flex tw-flex-col tw-items-start'>
            <p className='tw-mb-2'>{t("tickets.form.numeroTicket")}</p>
            <InputText
              value={values.numero ?? ""}
              className='!tw-w-full !tw-h-10 !tw-rounded'
              placeholder={`${t("tickets.form.placeholder.numero")}`}
              onChange={(e: SyntheticEvent<HTMLInputElement>) => {
                setFieldValue("numero", e.currentTarget.value)
              }}
            />
          </div> */}
      </div>

      <div
        className={`tw-flex tw-flex-col tw-px-4 tw-pb-4 lg:tw-pt-4 tw-bg-simple-10 lg:tw-rounded tw-shadow lg:tw-mt-4 ${
          isOpen ? "tw-block " : "tw-hidden"
        }  lg:tw-block`}
      >
        {!isMobile && (
          <p className='tw-m-0 tw-font-medium tw-text-lg tw-text-left'>
            {t("tickets.form.othersTicket")}
          </p>
        )}
        <div className='tw-grid tw-gap-4 lg:tw-mt-4'>
          <div className='tw-flex tw-flex-col tw-items-start'>
            <div className='tw-mb-2'>
              {t("tickets.form.cuentaBancariaTicket")}
            </div>
            <Dropdown
              disabled={isActiveReembolso}
              name='cuentasContables.bancariaId'
              value={values.cuentasContables?.bancariaId}
              onChange={handleCuentaBancaria}
              options={[
                { iban: t("tickets.notSelect"), id: null },
                ...(cuentaBancariaAll?.items || []),
              ]}
              optionLabel='iban'
              optionValue='id'
              editable={false}
              placeholder={`${t("tickets.form.placeholder.cuentaBancaria")}`}
              className={`${
                errors?.cuentasContables?.bancariaId &&
                touched?.cuentasContables?.bancariaId
                  ? "!tw-border-danger"
                  : ""
              } !tw-rounded tw-w-full tw-border-1 !tw-h-10 tw-items-center tw-align-middle`}
            />
          </div>
        </div>
        {errors?.cuentasContables?.bancariaId &&
          touched?.cuentasContables?.bancariaId && (
            <ErrorMessage
              name='cuentasContables.bancariaId'
              component='div'
              className='!tw-block !tw-w-full !tw-text-left !tw-text-danger'
            />
          )}

        <div className='tw-grid tw-gap-4 lg:tw-mt-4'>
          <div className='tw-flex tw-items-center'>
            <Checkbox
              id='reembolso'
              className='tw-mr-4'
              isChecked={isActiveReembolso}
              onClick={() => {
                setFieldValue("cuentasContables.bancariaId", null)
                handleReembolsoChange()
              }}
            />
            <label
              htmlFor='reembolso'
              className='tw-w-fit tw-flex tw-justify-center tw-items-center tw-rounded tw-m-0 tw-select-none'
            >
              {t("tickets.form.reembolso")}
            </label>
          </div>
          {isActiveReembolso && (
            <div className='tw-flex tw-flex-col tw-items-start'>
              <p className='tw-mb-2'>{t("tickets.form.employeeToReimburse")}</p>
              <DropdownContactos
                id='employee-reimburse'
                optionValue='id'
                pushDefaultOption={
                  data?.empleado?.id && {
                    id: data?.empleado?.id,
                    razonSocial: data?.empleado?.nombre,
                  }
                }
                value={
                  typeof values?.empleadoId === "string"
                    ? values?.empleadoId
                    : ""
                }
                onchange={({ value }: { value: string }) =>
                  setFieldValue("empleadoId", value)
                }
                placeholder={String(t("tickets.form.selectEmployee"))}
                className={`${
                  typeof values?.empleadoId === "boolean"
                    ? "!tw-border-danger"
                    : ""
                } !tw-rounded tw-w-full tw-border-1 !tw-h-10 tw-items-center tw-align-middle`}
              />
            </div>
          )}
        </div>
        {errors?.empleadoId && touched?.empleadoId && (
          <ErrorMessage
            name='empleadoId'
            component='div'
            className='!tw-block !tw-w-full !tw-text-left !tw-text-danger'
          />
        )}
      </div>
      <div className='tw-mt-2 tw-p-4 tw-bg-simple-10 sm:tw-shadow lg:tw-hidden'>
        <ButtonPrimeReact
          onClick={(e) => {
            e.preventDefault()
            handleSubmit()
          }}
          className='tw-w-full !tw-bg-secondary !tw-border-secondary'
          disabled={isSubmitting}
        >
          {isSubmitting ? (
            <div className='tw-flex tw-items-center tw-justify-center'>
              <FontAwesomeIcon
                icon={["fal", "circle-notch"]}
                className='tw-w-4 tw-h-4 tw-animate-spin'
              />
            </div>
          ) : (
            t("tickets.form.createTitle")
          )}
        </ButtonPrimeReact>
      </div>
      <PrimeReactModal
        visible={showPreviewImg}
        baseZIndex={20}
        ptContext={MODAL_STYLES}
        closable={false}
        keepInViewport={false}
        header={
          <div className='tw-flex tw-justify-end'>
            <FontAwesomeIcon
              icon={["fal", "xmark"]}
              className='tw-w-5 tw-h-5 tw-text-white'
              onClick={() => setShowPreviewImg(false)}
            />
          </div>
        }
        className='tw-rounded-lg tw-py-6 tw-px-6 tw-bg-black tw-h-full tw-w-full md:tw-w-3/4 tw-relative'
      >
        <img
          src={imageData}
          alt='preview-ticket'
          className='sm:tw-max-h-[80vh] tw-object-cover tw-absolute tw-top-1/2 tw-left-1/2 tw-transform -tw-translate-x-1/2 -tw-translate-y-1/2 tw-w-3/4'
        />
      </PrimeReactModal>
      {showCamera && (
        <MobileCamera
          onClose={() => setShowCamera(false)}
          onConfirm={onConfirm}
        />
      )}
    </div>
  )
}

export default ContentFromTickets
